import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

import { asFormOptionField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';
import { messages } from './messages';

export const ViewMultipleSelectInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formOptionField = asFormOptionField(formField);
	const intl = useIntl();

	if (formOptionField === undefined) {
		return <></>;
	}

	// if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
	const labels = formOptionField.value?.options?.map((item) => item.label);
	if (labels && formOptionField.value?.otherOptionText !== undefined) {
		if (formOptionField.value.otherOptionText?.trim() === '') {
			labels.push(intl.formatMessage(messages.otherOption));
		} else {
			labels.push(formOptionField.value.otherOptionText);
		}
	}

	return (
		<Box>
			<Text testId={`field-input-multiple-select-view-${fieldId}`}>
				{labels && labels.join(', ')}
			</Text>
		</Box>
	);
};
